const MAX_LIST_PAGES = 50;

interface Page<T> {
    items: T[];
    hasMore: boolean;
}

interface FetchAllPagesOptions<T> {
    fetchPage: (offset: number) => Promise<Page<T>>;
}

export async function fetchAllPages<T>({
    fetchPage,
}: FetchAllPagesOptions<T>): Promise<T[]> {
    const allItems: T[] = [];
    let offset = 0;
    let pagesFetched = 0;
    let hasMore = true;

    while (hasMore && pagesFetched < MAX_LIST_PAGES) {
        const page = await fetchPage(offset);
        pagesFetched += 1;

        if (page.items.length === 0) {
            return allItems;
        }

        allItems.push(...page.items);
        hasMore = page.hasMore;
        offset += page.items.length;
    }

    if (hasMore) {
        throw new Error("Too many results to load");
    }

    return allItems;
}
